<div class="db-cdn-info" [ngClass]="{'db-cdn-info-black': userSubscription.status === userSubscriptionStatus.canceled && !userSubscription.isExpired && !userSubscription.appsumoIsExpired && (userSubscription.canReactivate || userSubscription.paymentType === 'card')}">

  <div *ngIf="([UserSubscriptionType.PLATFORM].includes(userSubscription?.type) || userSubscription?.category === UserSubscriptionCategory.ENTERPRISE) && !userSubscription?.boosterProClient">
    <div class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title" *ngIf="userSubscription?.plan?.additionalCDNCount">
      <i class="db-icon db-icon-check"></i>
      <span>Cloudflare CDN add-on: {{userSubscription?.plan?.additionalCDNCount}}</span>
    </div>
    <div class="db-plan-label__wrap-body-feature" *ngIf="userSubscription?.plan?.additionalCDNCount">
      <i class="db-icon db-icon-circle-sm"></i>
      <span [innerHTML]="((userSubscription?.plan?.cdnAdditionalBandwidthValue * userSubscription?.plan?.additionalCDNCount) | size: {unit: 'MB'}) + ' CDN Bandwidth'"></span>
    </div>

    <div class="db-plan-label__wrap-body-feature db-plan-label__wrap-body-feature-title"
         *ngIf="userSubscription?.plan?.additionalDomainCount && !userSubscription?.boosterProClient">
      <i class="db-icon db-icon-check"></i>
      <span *ngIf="userSubscription?.additionalWebsiteCount">
        {{'website' | wordsByCount: userSubscription?.additionalWebsiteCount}}</span>
      <span *ngIf="userSubscription?.plan?.additionalDomainCount">Additional websites:
        {{userSubscription?.plan?.additionalDomainCount}}</span>
    </div>
    <div class="db-plan-label__wrap-body-feature"
         *ngIf="userSubscription?.plan?.additionalDomainCount && !userSubscription?.boosterProClient">
      <i class="db-icon db-icon-circle-sm"></i>
      <span>{{(userSubscription?.plan?.services?.hosting?.hosting_additional_visits?.parameter_value * userSubscription?.plan.additionalDomainCount / 1000 )}}K monthly visitors</span>
    </div>
    <div class="db-plan-label__wrap-body-feature"
         *ngIf="userSubscription?.plan?.additionalDomainCount && !userSubscription?.boosterProClient">
      <i class="db-icon db-icon-circle-sm"></i>
      <span [innerHTML]="((userSubscription?.plan?.services?.hosting?.hosting_additional_storage?.parameter_value *
          userSubscription?.plan?.additionalDomainCount * 1024 * 1024) | size) + ' SSD storage'"> </span>
    </div>
  </div>
</div>
